/* VESPER reveal — adds .in to .vesper .reveal when in view.
 * The hidden state is gated by html.vesper-ready, which we ONLY add on the live
 * storefront — never in the theme editor — so edits render live (no blank-until-save),
 * and content is never stuck hidden if JS fails. */
(function () {
  var dm = window.Shopify && window.Shopify.designMode;

  function revealIn(scope) {
    var els = (scope || document).querySelectorAll('.vesper .reveal:not(.in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < (window.innerHeight || 800) * 0.94 && r.bottom > 0) el.classList.add('in');
      else io.observe(el);
    });
  }

  function boot() {
    // In the editor, leave everything visible (don't arm the hidden CSS).
    if (dm) return;
    document.documentElement.classList.add('vesper-ready');
    revealIn(document);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // When a section is added/edited in the theme editor, make sure its content shows.
  document.addEventListener('shopify:section:load', function (e) {
    if (!dm) revealIn(e.target);
    // In design mode nothing is hidden, so no action needed.
  });
})();
